const UA = window.navigator.userAgent.toLowerCase()

export const isMobile = !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(UA)
